import { render } from "./Commission.vue?vue&type=template&id=6cdf3791"
import script from "./Commission.vue?vue&type=script&lang=js"
export * from "./Commission.vue?vue&type=script&lang=js"

import "./Commission.vue?vue&type=style&index=0&id=6cdf3791&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__